import { render, staticRenderFns } from "./FormFieldWithRequiredIcon.vue?vue&type=template&id=3efae971&scoped=true&"
import script from "./FormFieldWithRequiredIcon.vue?vue&type=script&lang=ts&"
export * from "./FormFieldWithRequiredIcon.vue?vue&type=script&lang=ts&"
import style0 from "./FormFieldWithRequiredIcon.vue?vue&type=style&index=0&id=3efae971&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efae971",
  null
  
)

export default component.exports